import { Postnummer } from '../generated-types';

export function ikkeInnenforGeoomraade(postnummer: Postnummer[], postnr: string | null | undefined) {
    return postnummer?.length > 0 && postnr?.length === 4 && !postnummer?.some((p) => p.value === postnr);
}
